import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { appendCounter, minusCounter, onChangeTab, onLoadActiveCustomer, onRegisterLeads, onSearchActiveCustomer, onShareLinkWithRef, onSortActiveCustomer, onTrackCustomerJourney, viewDetails } from "./actions";
import { isMobile } from "../../configs/utils";
import { ActiveCustomerMobEmptyStateStack } from "./indexMobEmptyState";
import { PartnerHeader } from "../dashboard/partnerHeader";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../../partnerWeb_Features/partnerSignUp/actions";
import { onLogoutPress, openMenu } from "../dashboard/actions";
import { PlatformSideNav } from "../../partnerWeb_Features/sideNavBar/platformSideNav";
import { platformApi, StoreKey } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import sharedPropsService from "../../SharedPropsService";
import { ActiveCustomerTableBuilder } from "../dashboard/utils";
import { ActiveCustomerMobStack } from "./indexMob";
import { debounce } from 'lodash';
const _isMobile = isMobile();
export const template = async (firstRenderArray, partnerLeadsData, totalNoOfPages, currentPageNo) => {
    return ({
        layout: {
            id: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                {
                    id: 'partnerHeader',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_TOP,
                },
                _isMobile ? {} : { id: 'sideNav', type: WIDGET.STACK, position: POSITION.NAVBAR_LEFT },
                _isMobile ? { id: 'activeCustomerMobRootStack', type: WIDGET.STACK } : {
                    id: 'activeCustomerPageRootStack',
                    type: WIDGET.STACK
                },
            ],
        },
        datastore: {
            ...(await PartnerHeader(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, true)),
            ...await PlatformSideNav(ROUTE.PLATFORM_ACTIVE_CUSTOMERS),
            ...await ActiveCustomerMobStack(partnerLeadsData),
            ...await ActiveCustomerMobEmptyStateStack(),
            activeCustomerPageRootStack: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.MATCH_PARENT,
                type: StackType.column,
                flex: 1,
                padding: {
                    top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                    left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                    right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                },
                widgetItems: firstRenderArray?.length > 0
                    ? [
                        { id: 'activeCustomerCountText', type: WIDGET.TEXT },
                        { id: 'activeCustomerCountText2', type: WIDGET.TEXT },
                        { id: 'activeCustomerspace0', type: WIDGET.SPACE },
                        { id: 'activeCustomertopStack', type: WIDGET.STACK },
                        { id: 'activeCustomerspace2', type: WIDGET.SPACE },
                        { id: 'spaceStack', type: WIDGET.STACK },
                        { id: 'activeCustomerTable', type: WIDGET.TABLE },
                        { id: "pageNumberStack", type: WIDGET.STACK },
                        { id: "activeCustomerspace0", type: WIDGET.SPACE },
                    ]
                    : [
                        { id: 'activeCustomerCountText', type: WIDGET.TEXT },
                        { id: 'activeCustomerCountText2', type: WIDGET.TEXT },
                        { id: 'activeCustomerMobEmptyStateStack', type: WIDGET.STACK }
                    ],
            },
            spaceStack: {
                type: StackType.column,
                hide: true,
                widgetItems: [
                    { id: 'activeCustomerspace1', type: WIDGET.SPACE },
                ]
            },
            pageNumberStack: {
                type: StackType.row,
                justifyContent: StackJustifyContent.spaceBetween,
                width: StackWidth.MATCH_PARENT,
                padding: {
                    top: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                    left: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.NONE,
                    right: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.NONE,
                },
                widgetItems: [
                    {
                        id: "previousPageStack", type: WIDGET.STACK
                    },
                    {
                        id: "pageNumberMentionStack", type: WIDGET.STACK
                    },
                    {
                        id: "nextPageStack", type: WIDGET.STACK
                    }
                ]
            },
            pageNumberMentionStack: {
                type: StackType.row,
                widgetItems: [
                    { id: "currentPageNumber", type: WIDGET.TEXT },
                    { id: "pageNumber", type: WIDGET.TEXT },
                ]
            },
            currentPageNumber: {
                label: `Page ${currentPageNo}`,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            pageNumber: {
                label: ` of ${totalNoOfPages}`,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            previousPageStack: {
                type: StackType.row,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    {
                        id: "leftIcon", type: WIDGET.ICON
                    },
                    {
                        id: "previousText", type: WIDGET.TEXT
                    }
                ],
                action: {
                    routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                    type: ACTION.MINUS_COUNTER
                }
            },
            nextPageStack: {
                type: StackType.row,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    {
                        id: "nextText", type: WIDGET.TEXT
                    },
                    {
                        id: "rightIcon", type: WIDGET.ICON
                    },
                ],
                action: {
                    routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                    type: ACTION.APPEND_COUNTER,
                    payload: {
                        value: currentPageNo,
                        array: partnerLeadsData,
                        totalNoOfPages: totalNoOfPages
                    }
                }
            },
            leftIcon: {
                name: IconTokens.LeftBlackArrowIcon,
                size: IconSizeTokens.XL,
                color: ColorTokens.Grey_Charcoal
            },
            rightIcon: {
                name: IconTokens.RightBlackIcon,
                size: IconSizeTokens.XL,
                color: ColorTokens.Grey_Night
            },
            previousText: {
                label: 'Previous',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            nextText: {
                label: 'Next',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
                color: ColorTokens.Grey_Night
            },
            activeCustomerCountText: {
                label: `Customers`,
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.LG,
                fontWeight: '600',
                lineHeight: 26,
                color: ColorTokens.Grey_Night
            },
            activeCustomerTable: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.MATCH_PARENT,
                titleMap: {
                    ...ActiveCustomerTableBuilder(firstRenderArray).Title_MAP,
                },
                titleConfig: {
                    ...ActiveCustomerTableBuilder(firstRenderArray).TITLE_CONFIG,
                },
                widgetData: {
                    ...ActiveCustomerTableBuilder(firstRenderArray).DATA,
                },
                data: firstRenderArray,
                sortAction: {
                    type: ACTION.ON_SORT_AC,
                    routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                    payload: {
                        value: '',
                    },
                },
            },
            ...ActiveCustomerTableBuilder(firstRenderArray)
                .DATA_STORE,
            activeCustomerCountText2: {
                label: `Track your active customers`,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontWeight: '400',
                lineHeight: 20,
            },
            activeCustomertopStack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: 'activeCustomerSearchStackLeft', type: WIDGET.STACK },
                    { id: 'activeCustomerSearchStackRight', type: WIDGET.STACK },
                ],
            },
            activeCustomerSearchStackLeft: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                flex: 1,
                widgetItems: [
                    { id: 'activeCustomerSeachInput', type: WIDGET.INPUT },
                ],
            },
            activeCustomerSearchStackRight: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                flex: 2,
                widgetItems: [],
            },
            activeCustomerSeachInput: {
                title: 'Search Active Customers',
                value: '',
                placeholder: 'Search by name and mobile',
                type: InputTypeToken.DEFAULT,
                action: {
                    routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                    type: ACTION.ON_SEARCH_AC
                }
            },
            activeCustomerspace0: { size: SizeTypeTokens.XXXL },
            activeCustomerspace1: { size: SizeTypeTokens.LG },
            activeCustomerspace2: { size: SizeTypeTokens.LG },
        }
    });
};
export const platformActiveCustomersMF = {
    onLoad: async ({ asyncStorage, network, instrumentTrack, ...props }, { setIsUserLoggedIn: boolean, }) => {
        const header = await getAppHeader();
        header['X-AppPlatform'] = await asyncStorage.get(StoreKey.APP_PLATFORM);
        const response = await network.get(`${platformApi.activeCustomers}1`, {
            headers: header
        }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        const array = [];
        let firstRenderArray = [];
        firstRenderArray = response.data.activeCustomerDetails;
        const totalNoOfPages = response?.data?.totalPages;
        const currentPageNo = response?.data?.currentPageNumber;
        if (firstRenderArray.length > 0) {
            for (let i = currentPageNo; i <= totalNoOfPages; i++) {
                network.get(`${platformApi.activeCustomers}${i}`, {
                    headers: header
                }, async () => {
                    return;
                }, {
                    isPartnerPlatform: true,
                }).then(response => {
                    array.push(...response.data.activeCustomerDetails);
                    sharedPropsService.setActiveCustomersList(array);
                });
            }
        }
        return Promise.resolve(template(firstRenderArray, array, totalNoOfPages, currentPageNo));
    },
    actions: {
        [ACTION.ON_SEARCH_AC]: debounce(onSearchActiveCustomer, 500),
        [ACTION.ON_LOAD]: onLoadActiveCustomer,
        [ACTION.ON_SORT_AC]: onSortActiveCustomer,
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.ON_TRACK_CUSTOMER_JOURNEY]: onTrackCustomerJourney,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.VIEW_DETAILS]: viewDetails,
        [ACTION.SHARE_LINK_REF]: onShareLinkWithRef,
        [ACTION.ON_REGISTER_LEADS]: onRegisterLeads,
        [ACTION.MINUS_COUNTER]: minusCounter,
        [ACTION.APPEND_COUNTER]: appendCounter,
    },
};
